import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import ToastContainer from './components/ToastContainer';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MatrimonyPage from './pages/MatrimonyPage';
import ProfileDetailPage from './pages/ProfileDetailPage';
import CreateProfilePage from './pages/CreateProfilePage';
import NewsPage from './pages/NewsPage';
import PostDetailPage from './pages/PostDetailPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPosts from './pages/admin/AdminPosts';
import AdminProfiles from './pages/admin/AdminProfiles';
import AdminUsers from './pages/admin/AdminUsers';

import './styles/design-system.css';
import './styles/Toast.css';
import './styles/LoadingSkeleton.css';
import './styles/ErrorBoundary.css';
import './styles/ImageUpload.css';
import './styles/ConfirmModal.css';

const AdminRoute = ({ children }) => {
  const { currentUser, isAdmin, loading } = useAuth();
  if (loading) return null;
  if (!currentUser || !isAdmin) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <Router>
            <div className="app-wrapper">
              <Navbar />
              <ToastContainer />
              <main className="main-content">
                <Routes>
                  {/* Public */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/news" element={<NewsPage />} />
                  <Route path="/post/:postId" element={<PostDetailPage />} />

                  {/* Matrimony — ✅ /create MUST come before /:profileId */}
                  <Route path="/matrimony" element={<MatrimonyPage />} />
                  <Route path="/matrimony/create" element={<CreateProfilePage />} />
                  <Route path="/matrimony/:profileId" element={<ProfileDetailPage />} />
                  <Route path="/create-profile" element={<CreateProfilePage />} />

                  {/* Admin */}
                  <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                  <Route path="/admin/posts" element={<AdminRoute><AdminPosts /></AdminRoute>} />
                  <Route path="/admin/profiles" element={<AdminRoute><AdminProfiles /></AdminRoute>} />
                  <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;